// shopConstants.js
'use strict';

export const SHOP_ID = {
  addvalue: 'addvalue',
  topup: 'top-up',
  messagePack: 'messagePack',
  subscription: 'subscription',
};

export const ORDER_EMAIL_FALLBACK = 'swag.receipt@gmail.com';

export const orderStatusConstant = {
  PENDING: 'pending',
  SUCCEEDED: 'succeeded',
  CANCELLED: 'cancelled',
  FAILED: 'failed',
};

export const orderStatusWhiteList = [
  orderStatusConstant.PENDING,
  orderStatusConstant.SUCCEEDED,
  orderStatusConstant.CANCELLED,
  orderStatusConstant.FAILED,
];

export const PaymentMethodUsage = {
  SUBSCRIPTION: 'subscription',
  TOP_UP: 'top-up',
  ALL: 'all',
};

export const PaymentGateway = {
  SECURIONPAY: 'securionpay',
  TAPPAY: 'tappay',
  ECPAY: 'ecpay',
  CENTROBILL: 'centrobill',
  NINEONE_APP: 'nineoneapp',
};

export const ProductType = {
  DIAMONDS: 'diamonds',
  SUBSCRIPTIONS: 'subscriptions',
  MESSAGEPACKS: 'messagepacks',
  PASSES: 'passes_v2',
};

export const ProductPassType = {
  LIVESTREAM_PASS: 'livestream_pass',
  STORY_FEED_PASS: 'story_feed_pass',
  FLIX_FEED_PASS: 'flix_feed_pass',
};

export const SHOP_ROOT = 'shop-root';

export const InternalCurrency = {
  DIAMONDS: 'DIAMONDS',
};

export const OrderStatus = {
  BOUGHT: 'bought',
};

export const ServerOrderStatus = {
  PAID: 'paid',
  FULFILLED: 'fulfilled',
  REFUNDED: 'refunded',
};

export const PASSES_PRODUCT_QUANTITY = 1;

export const ProductNoticeClickAction = {
  CHECKOUT: 'checkout',
  USER_LEVEL_BENEFIT: 'user-level-benefit',
  SOLD_OUT: 'sold-out',
};

export const PaymentSourceType = {
  CARD: 'card',
};

export const FAKE_LAST4 = '****';

export const ShopSectionType = {
  AD: 'ad',
  ANCHOR: 'anchor',
  SECTION: 'section',
};

export const CurrencyToCountryMap = {
  EUR: 'eu',
  USD: 'us',
};

export const CarrierType = {
  DONATE: null,
  MOBILE: 0,
  MEMBER: 2,
};

export const MOBILE_CARRIER_LENGTH = 8;

export const MOBILE_CARRIER_REGEX = /^\/[0-9A-Z+\-.]{7}$/;

const QUICKPAY_BUNDLE_SECTION_PREFIX = 'quickpay-bundle-options-zero-purchase';

export const QUICKPAY_BUNDLE_SECTION = {
  CHAT: `${QUICKPAY_BUNDLE_SECTION_PREFIX}-open-livestream-chat-section`,
  COMMAND: `${QUICKPAY_BUNDLE_SECTION_PREFIX}-send-command-section`,
  EXCLUSIVE: `${QUICKPAY_BUNDLE_SECTION_PREFIX}-join-exclusive-livestream-section`,
  GIFT: `${QUICKPAY_BUNDLE_SECTION_PREFIX}-send-gift-section`,
  TOY_COMMAND: `${QUICKPAY_BUNDLE_SECTION_PREFIX}-send-lovense-command-section`,
  POST: `${QUICKPAY_BUNDLE_SECTION_PREFIX}-unlock-post-section`,
  PRIVATE: `${QUICKPAY_BUNDLE_SECTION_PREFIX}-join-private-livestream-section`,
  SHORTS: `${QUICKPAY_BUNDLE_SECTION_PREFIX}-unlock-shorts-section`,
  SHOW: `${QUICKPAY_BUNDLE_SECTION_PREFIX}-join-show-section`,
  STORY: `${QUICKPAY_BUNDLE_SECTION_PREFIX}-unlock-story-section`,
  SUPPORT: `${QUICKPAY_BUNDLE_SECTION_PREFIX}-show-support-swagger-section`,
  VIDEO: `${QUICKPAY_BUNDLE_SECTION_PREFIX}-unlock-video-section`,
};
